var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a, _b;
import { logger } from './logger';
import { DataPacket_Kind, Room, RoomEvent, Track, } from 'livekit-client';
import { MediaProvider, TrackType, } from '@withso/pop-media-sdk';
var liveKitSourceMap = (_a = {},
    _a[TrackType.Camera] = Track.Source.Camera,
    _a[TrackType.Microphone] = Track.Source.Microphone,
    _a[TrackType.Screen] = Track.Source.ScreenShare,
    _a[TrackType.ScreenAudio] = Track.Source.ScreenShareAudio,
    _a);
var trackTypeMap = (_b = {},
    _b[Track.Source.Camera] = TrackType.Camera,
    _b[Track.Source.Microphone] = TrackType.Microphone,
    _b[Track.Source.ScreenShare] = TrackType.Screen,
    _b[Track.Source.ScreenShareAudio] = TrackType.ScreenAudio,
    _b);
var LiveKitProvider = /** @class */ (function (_super) {
    __extends(LiveKitProvider, _super);
    function LiveKitProvider(endpoint, roomOptions) {
        if (roomOptions === void 0) { roomOptions = {}; }
        var _this = _super.call(this) || this;
        _this.endpoint = endpoint;
        _this.roomOptions = roomOptions;
        _this._room = null;
        _this.connectToRoom = function (mediaToken, localTracks) { return __awaiter(_this, void 0, void 0, function () {
            var room, _a, _b, participant;
            var e_1, _c;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        room = new Room(__assign(__assign({}, this.roomOptions), { 
                            // this is necessary to enforce to maintain SDK behavior consistency
                            stopLocalTrackOnUnpublish: false }));
                        this._room = room;
                        logger.debug('[LiveKit] connected, local participant SID', room.localParticipant.sid);
                        room.on(RoomEvent.Disconnected, this.handleDisconnect);
                        room.on(RoomEvent.Reconnected, this.handleReconnect);
                        room.on(RoomEvent.Reconnecting, this.handleReconnecting);
                        room.on(RoomEvent.ParticipantConnected, this.handleParticipantConnected);
                        room.on(RoomEvent.ParticipantDisconnected, this.handleParticipantDisconnected);
                        room.on(RoomEvent.TrackSubscribed, this.handleTrackSubscribed);
                        room.on(RoomEvent.TrackUnsubscribed, this.handleTrackUnsubscribed);
                        room.on(RoomEvent.DataReceived, this.handleData);
                        room.on(RoomEvent.LocalTrackPublished, this.handleLocalTrackPublished);
                        room.on(RoomEvent.LocalTrackUnpublished, this.handleLocalTrackUnpublished);
                        return [4 /*yield*/, room.connect(this.endpoint, mediaToken)];
                    case 1:
                        _d.sent();
                        // immediately trigger connection events for all existing participants
                        this.handleParticipantConnected(room.localParticipant);
                        try {
                            for (_a = __values(room.participants.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
                                participant = _b.value;
                                this.handleParticipantConnected(participant);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        // immediately publish local tracks
                        return [4 /*yield*/, Promise.all(Object.entries(localTracks).map(function (_a) {
                                var _b = __read(_a, 2), trackType = _b[0], track = _b[1];
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_c) {
                                        switch (_c.label) {
                                            case 0:
                                                if (!track) return [3 /*break*/, 2];
                                                return [4 /*yield*/, this.startMediaInternal(trackType, track)];
                                            case 1:
                                                _c.sent();
                                                logger.debug('[LiveKit] published initial local track', trackType);
                                                _c.label = 2;
                                            case 2: return [2 /*return*/];
                                        }
                                    });
                                });
                            }))];
                    case 2:
                        // immediately publish local tracks
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleDisconnect = function () {
            logger.debug('[LiveKit] disconnected');
            _this.onDisconnect();
        };
        _this.handleReconnecting = function () {
            logger.debug('[LiveKit] reconnecting');
            _this.onReconnecting();
        };
        _this.handleReconnect = function () {
            logger.debug('[LiveKit] reconnected');
            _this.onReconnect();
        };
        _this.handleParticipantConnected = function (participant) {
            var e_2, _a;
            logger.debug("[LiveKit] participant connected: ".concat(participant.sid));
            // get the participant ID - it's stored as their identity
            var appId = participant.identity;
            _this.onParticipantConnected(participant.sid, appId);
            try {
                // immediately trigger start events for all participant tracks
                for (var _b = __values(participant.tracks.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var track = _c.value;
                    if (track.track) {
                        _this.handleTrackSubscribed(track.track, track, participant);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        };
        _this.handleParticipantDisconnected = function (participant) {
            var e_3, _a;
            logger.debug("[LiveKit] participant disconnected: ".concat(participant.sid));
            _this.onParticipantDisconnected(participant.sid);
            try {
                // immediately trigger end events for all participant tracks
                for (var _b = __values(participant.tracks.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var track = _c.value;
                    if (track.track) {
                        _this.handleTrackUnsubscribed(track.track, track, participant);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        };
        _this.getTrackType = function (track) {
            if (track.source === Track.Source.Unknown || !track.source) {
                // try the name...
                return track.trackName;
            }
            return trackTypeMap[track.source];
        };
        _this.handleTrackSubscribed = function (track, pub, participant) {
            logger.debug("[LiveKit] track subscribed: ".concat(track.sid, " by ").concat(participant.sid, ". MediaStreamTrack ID: ").concat(track.mediaStreamTrack.id));
            if (!track.sid) {
                // TODO: what?
                logger.error('[LiveKit] track has no SID');
                return;
            }
            var trackType = _this.getTrackType(pub);
            _this.onTrackSubscribed(participant.sid, trackType);
        };
        _this.handleTrackUnsubscribed = function (track, pub, participant) {
            logger.debug("[LiveKit] track unsubscribed: ".concat(track.sid, " by ").concat(participant.sid));
            if (!track.sid) {
                // TODO: what?
                logger.error('[LiveKit] track has no SID');
                return;
            }
            var trackType = _this.getTrackType(pub);
            if (!trackType) {
                logger.warn('[LiveKit] track unsubscribed but track type not recognized', track.sid, participant.sid);
                return;
            }
            _this.onTrackUnsubscribed(participant.sid, trackType);
        };
        _this.disconnectFromRoom = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._room) {
                    this._room.disconnect(false);
                    // act as if our own participant disconnected - LiveKit will not fire these
                    // events like it would for remote participants
                    this.handleParticipantDisconnected(this._room.localParticipant);
                    this._room = null;
                }
                return [2 /*return*/];
            });
        }); };
        _this.getMediaStreamTrack = function (participantSid, trackSid) {
            var _a, _b, _c, _d;
            if (!_this._room)
                return null;
            var participant;
            if (_this._room.localParticipant.sid === participantSid) {
                participant = _this._room.localParticipant;
            }
            else {
                participant = (_a = _this._room.participants.get(participantSid)) !== null && _a !== void 0 ? _a : null;
            }
            if (!participant) {
                logger.warn("[LiveKit] Participant with sid ".concat(participantSid, " not found"));
                return null;
            }
            var mediaTrackPub = (_b = participant.tracks.get(trackSid)) !== null && _b !== void 0 ? _b : null;
            if (!mediaTrackPub) {
                logger.warn("[LiveKit] Media track with sid ".concat(trackSid, " not found"));
                return null;
            }
            return (_d = (_c = mediaTrackPub.track) === null || _c === void 0 ? void 0 : _c.mediaStreamTrack) !== null && _d !== void 0 ? _d : null;
        };
        _this.getLocalParticipantSid = function () {
            var _a, _b;
            return (_b = (_a = _this._room) === null || _a === void 0 ? void 0 : _a.localParticipant.sid) !== null && _b !== void 0 ? _b : null;
        };
        _this.publishLocalMedia = function (trackType, mediaTrack) { return __awaiter(_this, void 0, void 0, function () {
            var pub;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._room) {
                            throw new Error('Cannot start media before room is connected');
                        }
                        return [4 /*yield*/, this._room.localParticipant.publishTrack(mediaTrack, {
                                name: trackType,
                                source: liveKitSourceMap[trackType],
                            })];
                    case 1:
                        pub = _a.sent();
                        logger.debug('[LiveKit] published track', pub.trackSid, liveKitSourceMap[trackType]);
                        return [2 /*return*/, pub.trackSid];
                }
            });
        }); };
        _this.unpublishLocalMedia = function (trackSid) { return __awaiter(_this, void 0, void 0, function () {
            var pub;
            return __generator(this, function (_a) {
                if (!this._room)
                    return [2 /*return*/];
                pub = this._room.localParticipant.tracks.get(trackSid);
                if (!(pub === null || pub === void 0 ? void 0 : pub.track))
                    return [2 /*return*/];
                logger.debug('[LiveKit] unpublished track', pub.trackSid);
                this._room.localParticipant.unpublishTrack(pub.track);
                return [2 /*return*/];
            });
        }); };
        _this.handleLocalTrackPublished = function (pub) { return __awaiter(_this, void 0, void 0, function () {
            var trackType;
            return __generator(this, function (_a) {
                trackType = this.getTrackType(pub);
                if (this._room) {
                    this.onLocalTrackPublished(trackType);
                }
                return [2 /*return*/];
            });
        }); };
        _this.handleLocalTrackUnpublished = function (pub) { return __awaiter(_this, void 0, void 0, function () {
            var trackType;
            return __generator(this, function (_a) {
                trackType = this.getTrackType(pub);
                if (this._room) {
                    this.onLocalTrackUnpublished(trackType);
                }
                return [2 /*return*/];
            });
        }); };
        _this.getParticipantBySid = function (sid) {
            var _a;
            if (!_this._room)
                return null;
            if (_this._room.localParticipant.sid === sid) {
                return _this._room.localParticipant;
            }
            return (_a = _this._room.participants.get(sid)) !== null && _a !== void 0 ? _a : null;
        };
        _this.getParticipantIdFromSid = function (sid) {
            var _a, _b;
            return (_b = (_a = _this.getParticipantBySid(sid)) === null || _a === void 0 ? void 0 : _a.identity) !== null && _b !== void 0 ? _b : null;
        };
        _this.getTrackTypeFromTrackSid = function (participantSid, trackSid) {
            if (!_this._room)
                return null;
            var participant = _this.getParticipantBySid(participantSid);
            var pub = participant === null || participant === void 0 ? void 0 : participant.tracks.get(trackSid);
            if (!(pub === null || pub === void 0 ? void 0 : pub.track))
                return null;
            return _this.getTrackType(pub);
        };
        _this.getParticipantTrackSids = function (participantSid) {
            if (!_this._room)
                return [];
            var participant = _this.getParticipantBySid(participantSid);
            if (!participant)
                return [];
            return Array.from(participant.tracks.keys());
        };
        _this.textEncoder = new TextEncoder();
        _this.textDecoder = new TextDecoder('utf-8');
        _this.handleData = function (message, participant) {
            if (!participant) {
                logger.warn('[LiveKit] data received from unknown participant');
                return;
            }
            _this.onMessage(participant.sid, _this.textDecoder.decode(message));
        };
        return _this;
    }
    LiveKitProvider.prototype.sendMessage = function (message) {
        if (!this._room)
            return;
        this._room.localParticipant.publishData(this.textEncoder.encode(message), DataPacket_Kind.LOSSY);
    };
    return LiveKitProvider;
}(MediaProvider));
export { LiveKitProvider };
//# sourceMappingURL=LiveKitProvider.js.map